import { SurveyQualification } from '../models';

export const DEFAULT_SURVEY_QUALIFICATION: SurveyQualification = {
  qualificationCode: 0,
  qualificationName: '',
  key: '',
  isDefault: false,
  isAllSet: false,
  isQuotaSet: false,
  hasDependency: false,
  isRangeType: false,
  conditionCodes: [],
  data: [],
};

// Two distinct concepts that both mean "spans more than one qualification": the label the
// drawer/qualification views render, and the sentinel the feasibility wire expects in quota_type.
export const NESTED_QUOTA_LABEL = 'NESTED';

export const NESTED_QUOTA_TYPE = 'autoNested';

export const CENSUS_LABEL = 'CENSUS';

export type AppliedQuotaLabel =
  | typeof NESTED_QUOTA_LABEL
  | typeof CENSUS_LABEL
  | '';

// Advanced Targeting qualifications are distinguished from core/location ones by
// a numeric convention on the qualification code, not by a flag on the payload.
// Mirrors the legacy ADVANCE_TARGETING_QUAL_ID_START_INDEX.
export const ADVANCED_TARGETING_QUALIFICATION_CODE_MIN = 1000;
